export default function resolveScope(path: string, scope: string[]) {
  if (path.startsWith('/')) {
    return path.substring(1);
  }

  if (path.startsWith('../')) {
    const propertyPath = path.replace(/^(\.\.\/)+/, '');
    const scopeOffset = (path.length - propertyPath.length) / 3;
    const offsettedScope = scope.slice(0, -1 * scopeOffset);
    return [...offsettedScope, propertyPath]
      .filter((p) => p)
      .join('.');
  }

  return [...scope, path].join('.');
}
